// extracted by mini-css-extract-plugin
export default {"LayoutInputsColumn":"layout-inputs-column_LayoutInputsColumn__IAiMX"};